import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApiResponse,
  PresetCategoriesListResponse,
  PresetCategoryDetail,
  CreatePresetCategoryRequest,
  UpdatePresetCategoryRequest,
} from '../models/preset-categories.models';
import { PresetCategoriesApiService } from './preset-categories-api.service';

@Injectable({
  providedIn: 'root',
})
export class PresetCategoriesService {
  private readonly apiService = inject(PresetCategoriesApiService);

  getCategories(
    pageNumber: number = 1,
    pageSize: number = 20,
    search?: string,
    isActive?: boolean,
  ): Observable<ApiResponse<PresetCategoriesListResponse>> {
    return this.apiService.getCategories(pageNumber, pageSize, search, isActive);
  }

  getCategory(id: number): Observable<ApiResponse<PresetCategoryDetail>> {
    return this.apiService.getCategory(id);
  }

  createCategory(payload: CreatePresetCategoryRequest): Observable<ApiResponse<PresetCategoryDetail>> {
    return this.apiService.createCategory(payload);
  }

  updateCategory(id: number, payload: UpdatePresetCategoryRequest): Observable<ApiResponse<PresetCategoryDetail>> {
    return this.apiService.updateCategory(id, payload);
  }

  deleteCategory(id: number): Observable<ApiResponse<string>> {
    return this.apiService.deleteCategory(id);
  }
}
